module.exports = __webpack_public_path__ + "static/media/NoMessagesCreatedIcon.3e312c17.svg";